import React, { FocusEvent, useState } from 'react';
import { uniqueId } from 'es-toolkit/compat';

import { DropdownProps } from './types';
import { NoSSRComponent } from '@/migrated-widgets/table-map/utils/ssr';
import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';



function Dropdown({ trigger, children: items, dropdownList = { className: '', width: 'w-full' }, className = '', value, itemsContainerClassName = '', triggerContainer = {}, listFooter, closeOnClick = false }: DropdownProps) {
  const [isOpen, setIsOpen] = useState<boolean>(value ?? false);
  const [id] = useState<string>(uniqueId('dropdown_'));

  const { className: dropdownListClassName, width: dropdownListWidth, ...dropdownListExtraProps } = dropdownList;
  function handleBlur(e: FocusEvent<HTMLElement>) {
    e.preventDefault();
    const relatedTarget = e.relatedTarget as HTMLElement;
    if (!relatedTarget?.classList?.contains(id)) {
      setIsOpen(false);
    }
  }
  function handleToggleDropdown() {
    if (isOpen) setIsOpen(false);
    else setIsOpen(true);
  }
  function handleCloseDropdown() {
    if (closeOnClick) setIsOpen(false);
  }
  return (
    <div onBlur={handleBlur} tabIndex={1} className={`z-20 ${id} w-full relative inline-block text-left outline-none ${className}`}>
      <div {...{
        ...triggerContainer, className: `${triggerContainer?.className || ''} cursor-pointer outline-none`
      }} onClick={handleToggleDropdown} >
        {trigger}
      </div>

      {
        isOpen && (
          <div className={twMerge(classNames(`${dropdownListWidth} max-h-96 overflow-y-auto origin-top-right absolute right-0 mt-2 overflow-x-hidden rounded-md shadow-xl bg-white ring-opacity-5 z-50`), dropdownListClassName ?? '')} {...dropdownListExtraProps}>
            <div className={`flex flex-col ${itemsContainerClassName}`} role="menu" aria-orientation="vertical" aria-labelledby="options-menu" onClick={() => handleCloseDropdown()}>
              {items}
              {listFooter}
            </div>
          </div>
        )
      }
    </div>
  )
}

export default NoSSRComponent<DropdownProps>(Dropdown);